import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function Login() {
    const [params] = useSearchParams();
    const next = params.get("next") || "";
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const res = await login(email, password);
        setLoading(false);
        if (res.ok) {
            toast.success(`Welcome back, ${res.user.name}`);
            if (next) navigate(next);
            else navigate(res.user.role === "startup" ? "/dashboard" : res.user.role === "admin" ? "/admin" : "/discover");
        } else {
            toast.error(res.error);
        }
    };

    return (
        <main className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6 py-12">
            <div className="w-full max-w-md">
                <p className="font-mono-tag text-xs uppercase text-brand-saffron mb-3">/ log in</p>
                <h1 className="font-display font-extrabold text-4xl md:text-5xl tracking-tighter uppercase mb-2">Welcome back.</h1>
                <p className="text-white/60 text-sm mb-8">Shoppers, founders, everyone.</p>

                <form onSubmit={submit} className="space-y-5">
                    <div>
                        <Label className="font-mono-tag text-xs uppercase text-white/70">Email</Label>
                        <Input
                            data-testid="login-email-input"
                            type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                            className="mt-2 bg-brand-ink border-white/15 h-12 rounded-md"
                        />
                    </div>
                    <div>
                        <Label className="font-mono-tag text-xs uppercase text-white/70">Password</Label>
                        <Input
                            data-testid="login-password-input"
                            type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                            className="mt-2 bg-brand-ink border-white/15 h-12 rounded-md"
                        />
                    </div>
                    <Button
                        data-testid="login-submit-btn"
                        type="submit" disabled={loading}
                        className="w-full h-12 bg-brand-saffron text-black hover:bg-brand-saffron/90 font-semibold rounded-md"
                    >
                        {loading ? "Signing you in..." : "Sign in"}
                    </Button>
                    <p className="text-[11px] text-white/50 text-center leading-relaxed">
                        By continuing you agree to our{" "}
                        <Link to="/terms" className="text-brand-saffron hover:underline">Terms</Link>
                        {" "}and{" "}
                        <Link to="/privacy" className="text-brand-saffron hover:underline">Privacy Policy</Link>.
                    </p>
                </form>

                <p className="text-white/60 text-sm mt-6 text-center">
                    New here? <Link to="/register" className="text-brand-saffron hover:underline">Create an account</Link>
                </p>
            </div>
        </main>
    );
}
